import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { lang } from '@/utils'

import award from '@/router/award'
import rules from '@/router/rules'
import score from '@/router/score'
import shippingCommission from '@/views/shippingCommission/index.vue'
import privacy from '@/views/privacy/index.vue'
import routerCount from '@core/router/routerCount'
import { destroyH5 } from '@core/utils/nativeAPI'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/orderMain'
  },
  {
    path: '/orderMain',
    name: 'orderMain',
    component: () => import('@/views/order/index.vue'), // 注意这里要带上 文件后缀.vue
    meta: {
      title: lang('寄快递')
    }
  },
  {
    path: '/goodInfo',
    name: 'GoodInfo',
    component: () => import('@/views/goodInfo/index.vue'), // 注意这里要带上 文件后缀.vue
    meta: {
      title: lang('物品信息')
    }
  },
  {
    path: '/sign',
    name: 'Sign',
    component: () => import('@/views/sign/index.vue'), // 注意这里要带上 文件后缀.vue
    meta: {
      title: lang('签名'),
      keepAlive: true
    }
  },
  {
    path: '/preview',
    name: 'Preview',
    component: () => import('@/views/preview/index.vue'), // 注意这里要带上 文件后缀.vue
    meta: {
      title: lang('预览'),
      keepAlive: true
    }
  },
  {
    path: '/clause',
    name: 'Clause',
    component: () => import('@/views/clause/index.vue'), // 注意这里要带上 文件后缀.vue
    meta: {
      title: lang('条款与条件'),
      keepAlive: true
    }
  },
  {
    path: '/sender',
    name: 'Sender',
    component: () => import('@/views/sender/index.vue'), // 注意这里要带上 文件后缀.vue
    meta: {
      title: lang('寄件人信息')
    }
  },
  {
    path: '/recipt',
    name: 'Recipt',
    component: () => import('@/views/recipt/index.vue'), // 注意这里要带上 文件后缀.vue
    meta: {
      title: lang('收件人信息')
    }
  },
  {
    path: '/order/detail',
    name: 'OrderDetail',
    component: () => import('@/views/order/detail.vue'),
    meta: {
      title: lang('订单详情')
    }
  },
  {
    path: '/succOrder',
    name: 'SuccOrder',
    component: () => import('@/views/succOrder/index.vue'), // 注意这里要带上 文件后缀.vue
    meta: {
      title: lang('下单成功')
    }
  },
  {
    path: '/contraband',
    name: 'Contraband',
    component: () => import('@/views/contraband/index.vue'), // 注意这里要带上 文件后缀.vue
    meta: {
      title: lang('违禁品信息')
    }
  },
  {
    path: '/stationList',
    name: 'StationList',
    component: () => import('@/views/station-list/stationList.vue'), // 注意这里要带上 文件后缀.vue
    meta: {
      title: lang('服务站点')
    }
  },
  {
    path: '/404',
    name: '404',
    meta: { title: '404' },
    component: () => import('@/views/notfound/index.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: privacy,
    meta: {
      title: '隐私协议'
    }
  },
  {
    path: '/shippingCommission',
    name: 'ShippingCommission',
    component: shippingCommission,
    meta: {
      title: '寄件提成',
      keepAlive: true, // init 缓存
      isApp: true
    }
  },
  ...award,
  ...rules,
  ...score
]

const router = createRouter({
  history: createWebHistory('/h5/'),
  routes
})
routerCount(router, () => {
  destroyH5()
})
export default router
